<template>
      <Footer>
          <div>
                <img  src="../assets/code.jpg" alt="">
                <div>
                    <h2>娃娃鱼动画</h2>
                    <p>拱墅区祥园路88号中国智慧信息产业园H楼7楼  0571-88077081</p>
                    <p>Copyright © 2015-2020    浙ICP备15008765号-1</p>
                </div>
          </div>
        </Footer>
</template>
<script>
export default {
    data(){
        return{

        }
    }
}
</script>
<style lang="less" scoped>
.ivu-layout-footer{
    background-color: #1F2D3D;
    color: #fff;
    >div{
        width:1000px;
        margin:0 auto;
        overflow: hidden;
        img{
            width: 144px;
            float: left;
        }
        >div{
            float: left;
            margin-left: 40px;
            p{
                margin:36px 0px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footerItem.vue